export default function getName(name) {
    return name?.split('/')?.slice(-1)[0]?.replaceAll('-', '')
}
